import React, { Component } from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router";
import { Route } from "react-router-dom";
import TrackableMemoryRouter from "./TrackableMemoryRouter";
import PageHeader from "../pageHeader";
import UserInfo from "../userInfo";
import MinimizeButton from "../../drawer/components/MinimizeButton";
import "./styles.scss";

class TransitionRouter extends Component {
	constructor(props, context) {
		super(props, context);
		this.generateTransitionRoutes = this.generateTransitionRoutes.bind(this);
	}

	generateTransitionRoutes({ location }) {
		const { children, isDrawer } = this.props;

		return (
			<React.Fragment>
				{isDrawer ? this.renderHeader() : null}
				<Route location={location} key={location.key}>
					<Switch>{children}</Switch>
				</Route>
			</React.Fragment>
		);
	}

	renderPageHeader(backlinkUrl) {
		const {
			isUserLoggedIn,
			userInfo,
			bookmakerName,
			betslipID,
			courseName,
			selectedBets,
			toggleBalanceVisibility,
			selectedBookmakerFeed,
			isDrawerMinimized,
			onMaximizeClick,
			onMinimizeClick,
			numberOfSelectedBets,
			isQuickslipMode,
			resetEmptyBetslip,
			resetQuickslip,
			isBetPlacedSuccessfully,
			clearPlacedBetDetails,
		} = this.props;

		let toggle;

		toggle = (event) => {
			event.stopPropagation();

			// Empty betslip ("Your Bet Slip is Empty")
			if (!isDrawerMinimized && numberOfSelectedBets === 0 && !isQuickslipMode) {
				return resetEmptyBetslip();
			}

			// All other scenarios
			return isDrawerMinimized ? onMaximizeClick() : onMinimizeClick();
		};

		// Quickslip (1 bet showing) or Bet Receipt page
		const quickslipWithBet =
			!isDrawerMinimized && numberOfSelectedBets === 1 && isQuickslipMode;
		if (quickslipWithBet || isBetPlacedSuccessfully) {
			// Do nothing (and allow click event to propagate)
			toggle = null;
		}

		return (
			<PageHeader backLinkUrl={backlinkUrl} toggle={toggle}>
				{isUserLoggedIn ? (
					<UserInfo
						{...userInfo}
						toggleBalanceVisibility={toggleBalanceVisibility}
						selectedBookmakerFeed={selectedBookmakerFeed}
					/>
				) : null}
				<MinimizeButton
					bookmakerName={bookmakerName}
					betslipID={betslipID}
					courseName={courseName}
					isQuickslipMode={isQuickslipMode}
					resetQuickslip={resetQuickslip}
					isBetPlacedSuccessfully={isBetPlacedSuccessfully}
					clearPlacedBetDetails={clearPlacedBetDetails}
					selectedBets={selectedBets}
				/>
			</PageHeader>
		);
	}

	renderHeader() {
		const forgottenPasswordPath = `/${this.props.selectedBookmakerFeed}/login`;

		return (
			<React.Fragment>
				<Route exact path='/' render={() => this.renderPageHeader(null)} />
				<Route path='/:feed/login' render={() => this.renderPageHeader('/')} />
				<Route path='/bet-receipt' render={() => this.renderPageHeader(null)} />
				<Route
					path='/:feed/forgotten-password'
					render={() => this.renderPageHeader(forgottenPasswordPath)}
				/>
				<Route path='/:feed/top-up' render={() => this.renderPageHeader("/")} />
			</React.Fragment>
		);
	}

	render() {
		return (
			<TrackableMemoryRouter
				onHistoryChanged={this.props.onHistoryChanged}
				trackedParams={this.props.trackedParams}
			>
				<Route render={this.generateTransitionRoutes} />
			</TrackableMemoryRouter>
		);
	}
}

TransitionRouter.defaultProps = {
	bookmakerName: null,
};
TransitionRouter.propTypes = {
	children: PropTypes.arrayOf(PropTypes.element).isRequired,
	betslipID: PropTypes.string,
	onHistoryChanged: PropTypes.func,
	trackedParams: PropTypes.string,
	selectedBookmakerFeed: PropTypes.string.isRequired,
	isDrawer: PropTypes.bool,
	isUserLoggedIn: PropTypes.bool,
	userInfo: PropTypes.shape({
		balance: PropTypes.number,
		showBalance: PropTypes.bool,
		currencySign: PropTypes.string,
	}),
	toggleBalanceVisibility: PropTypes.func,
	isDrawerMinimized: PropTypes.bool,
	onMaximizeClick: PropTypes.func,
	onMinimizeClick: PropTypes.func,
	numberOfSelectedBets: PropTypes.number,
	isQuickslipMode: PropTypes.bool,
	resetEmptyBetslip: PropTypes.func,
	resetQuickslip: PropTypes.func,
	isBetPlacedSuccessfully: PropTypes.bool,
	clearPlacedBetDetails: PropTypes.func,
	bookmakerName: PropTypes.string,
};

TransitionRouter.defaultProps = {
	onHistoryChanged: null,
	trackedParams: "",
	isDrawer: false,
	isUserLoggedIn: false,
	userInfo: {},
	betslipID: null,
	toggleBalanceVisibility: null,
	isDrawerMinimized: true,
	onMaximizeClick: null,
	onMinimizeClick: null,
	numberOfSelectedBets: 0,
	isQuickslipMode: false,
	resetEmptyBetslip: null,
	resetQuickslip: null,
	isBetPlacedSuccessfully: false,
	clearPlacedBetDetails: null,
};

export default TransitionRouter;



// WEBPACK FOOTER //
// /src/js/common/transitionRouter/TransitionRouter.jsx